/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOf
 */
export interface GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOf
     */
    'cardType': GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOf
     */
    'expiredDate': string;
}

export const GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum = typeof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum[keyof typeof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum];


